import React, {useState, Fragment, useRef, useEffect} from 'react';
import {Dialog, Transition} from '@headlessui/react';
import CloseIcon from '@mui/icons-material/Close';
import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';
import {useTranslation} from 'react-i18next';
import {getAcessoriosArtigo} from './api';

// import { Container } from './styles';

function AcessoriosModal({back, idPdf, artigo, acessorios, setAcessorios = () => {}}) {
    const cancelButtonRef = useRef(null);
    const {t} = useTranslation();
    const [acessoriosSelecionados, setAcessoriosSelecionados] = useState([]);

    const [AcRecebidos, setAcRecebidos] = useState([]);
    const [filtroDescricao, setFiltroDescricao] = useState('');
    const [filtroRef, setFiltroRef] = useState('');

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const acRecebidosFilt = AcRecebidos?.filter(x => x.label?.toUpperCase().includes(filtroDescricao?.toUpperCase()) && x.referencia?.toUpperCase().includes(filtroRef?.toUpperCase()));

    const handleCheckboxChange = item => {
        if (acessoriosSelecionados?.find(element => element.value == item.value) != null) {
            setAcessoriosSelecionados(acessoriosSelecionados?.filter(selected => selected.value != item.value));
        } else {
            setAcessoriosSelecionados([...acessoriosSelecionados, item]);
        }
    };

    useEffect(() => {
        getAcessoriosArtigo(artigo, lang).then(res => {
            setAcRecebidos(
                res.data.acessorios.map(e => {
                    return {
                        e,
                        value: e.referencia,
                        label: e.descricao,
                        referencia: e.referencia,
                        preco: 0,
                        quantidade: 1,
                    };
                }),
            );
        });
        if (acessorios) {
            setAcessoriosSelecionados(acessorios);
        }
    }, [acessorios]);

    return (
        <Transition.Root show as={Fragment}>
            <Dialog as="div" className="relative z-40" initialFocus={cancelButtonRef} onClose={() => back()}>
                <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className={`fixed inset-0 z-10 overflow-y-auto ${window.innerWidth <= 1023 && window.innerWidth >= 640 ? 'p-8' : ''} mb-20`}>
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                            <Dialog.Panel className="relative transform overflow-hidden rounded-[8px] bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-[900px] sm:max-h-[600px] ">
                                <div className="flex items-start justify-between px-4 py-2 border-b rounded-t bg-gray-50 border-gray-100">
                                    <h3 className="text-xl mt-2 font-semibold text-gray-600 ">{t('acessorios')}</h3>
                                    <button
                                        type="button"
                                        className="inline-flex justify-end rounded-[8px] text-gray-500 px-1 py-1 text-sm font-semibold  shadow-sm hover:bg-gray-200 sm:ml-3 sm:w-auto"
                                        onClick={() => {
                                            back();
                                            //   setShowForm(false);
                                            //   setOpen(false);
                                        }}>
                                        <CloseIcon />
                                    </button>
                                </div>

                                <div className="overflow-x-auto">
                                    <div className="table-wrp block max-h-96 relative min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px]">
                                        <table className=" overflow-y-auto w-full text-sm text-left text-gray-500 ">
                                            <thead className=" sticky top-0 z-20  text-xs text-gray-700 uppercase bg-gray-100 ">
                                                <tr>
                                                    <th scope="col" className="px-2 py-3"></th>
                                                    <th scope="col" className="px-2 py-3">
                                                        {t('referencia')}
                                                        <div className="relative mt-4">
                                                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                                                <svg
                                                                    className="w-4 h-4 text-gray-500 dark:text-gray-400"
                                                                    aria-hidden="true"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    fill="none"
                                                                    viewBox="0 0 20 20">
                                                                    <path
                                                                        stroke="currentColor"
                                                                        stroke-linecap="round"
                                                                        stroke-linejoin="round"
                                                                        stroke-width="2"
                                                                        d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                                                                    />
                                                                </svg>
                                                            </div>
                                                            <input
                                                                type="search"
                                                                id="default-search"
                                                                value={filtroRef}
                                                                className="block w-full p-2 pl-10 text-xs text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 "
                                                                placeholder={t('filtro')}
                                                                onChange={e => {
                                                                    setFiltroRef(e.target.value);
                                                                }}
                                                            />
                                                        </div>
                                                    </th>
                                                    <th scope="col" className="px-12 py-3">
                                                        {t('descricao')}
                                                        <div className="relative mt-4">
                                                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                                                <svg
                                                                    className="w-4 h-4 text-gray-500 dark:text-gray-400"
                                                                    aria-hidden="true"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    fill="none"
                                                                    viewBox="0 0 20 20">
                                                                    <path
                                                                        stroke="currentColor"
                                                                        stroke-linecap="round"
                                                                        stroke-linejoin="round"
                                                                        stroke-width="2"
                                                                        d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                                                                    />
                                                                </svg>
                                                            </div>
                                                            <input
                                                                type="search"
                                                                id="default-search"
                                                                value={filtroDescricao}
                                                                className="block w-full p-2 pl-10 text-xs text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 "
                                                                placeholder={t('filtro')}
                                                                onChange={e => {
                                                                    setFiltroDescricao(e.target.value);
                                                                }}
                                                            />
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className=" max-h-200">
                                                {acRecebidosFilt?.map(item => (
                                                    <tr className="odd:bg-white border-b cursor-pointer even:bg-gray-50  hover:bg-gray-50 ">
                                                        <td className="px-6 py-1">
                                                            <label className="relative inline-flex items-center cursor-pointer">
                                                                <input
                                                                    type="checkbox"
                                                                    id={item.value}
                                                                    value=""
                                                                    checked={acessoriosSelecionados?.find(el => el.value === item.value)}
                                                                    onChange={() => {
                                                                        handleCheckboxChange(item);
                                                                    }}
                                                                    className="sr-only peer"
                                                                />
                                                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300  rounded-full peer  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all  peer-checked:bg-blue-600"></div>
                                                            </label>
                                                        </td>

                                                        <td
                                                            className="px-2 py-1 text-blue-600 "
                                                            onClick={() => {
                                                                handleCheckboxChange(item);
                                                            }}>
                                                            {item.value}
                                                        </td>
                                                        <td
                                                            className="px-12 py-1 text-blue-600 "
                                                            onClick={() => {
                                                                handleCheckboxChange(item);
                                                            }}>
                                                            {item.label}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        {/* {semDados && !loading && <NotFound frase={t('semRegistos')} />} */}
                                    </div>
                                    {/* )} */}
                                </div>
                                <div className=" px-4 py-2 border-b rounded-t bg-gray-50 border-gray-100">
                                    <div className="flex flex-row justify-end p-2">
                                        <button
                                            type="button"
                                            className="inline-flex w-full  justify-center rounded-[4px] text-white bg-blue-500 px-2 py-1 text-sm font-semibold  shadow-sm hover:bg-gray-200 sm:ml-3 sm:w-auto"
                                            onClick={() => {
                                                setAcessorios(acessoriosSelecionados);
                                                back();
                                                //   setShowForm(false);
                                                //   setOpen(false);
                                            }}>
                                            {t('guardar')}
                                        </button>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}

export default AcessoriosModal;
